import axios from 'axios';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getAxiosCancelTokenSource } from '@/app.utils';

const ypoCommonState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        chairMessage: null,
        announcement: null,
        eventsList: [],
        membersList: [],
    };
};

const ypoCommonMutations = {
    [storeMutation.setChapterChairMessage]: (state, message) => {
        state.chairMessage = message || null;
    },

    [storeMutation.setChapterAnnouncement]: (state, data) => {
        state.announcement = data || null;
    },
    [storeMutation.setChapterAnnouncementData]: (state, data) => {
        state.eventsList = data.eventList || null;
        state.membersList = data.profileList || null;
    },
};

const ypoCommonActions = {
    [storeAction.getChapterChairMessage]: wrapAction(
        storeAction.getChapterChairMessage,
        ({ state, commit }, requestData) => {
            //resetting the state to null before making a new call
            commit(storeMutation.setChapterChairMessage);

            //preparing cancellable axios request
            const { communityId, communityTypeName } = requestData;
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getChapterChairMessage,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

            //TODO: using mock for now to test when Champs Page is set to get the actual
            return axios({
                url: `${state.baseURL}communities/api/communities/${communityId}/chair-messages/${communityTypeName}`,
                //url: `/mocks/chairMessage.json`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.setChapterChairMessage, response.data);
                    commit(storeMutation.removeCancelableRequest, storeAction.getChairMessage, { root: true });
                    return response;
                })
                .catch((err) => {
                    commit(storeMutation.setChapterChairMessage);
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getChapterAnnouncement]: wrapAction(storeAction.getAnnouncement, ({ state, commit }, communityId) => {
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getChapterAnnouncement,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, {
            root: true,
        });

        return axios({
            url: `${state.baseURL}communities/api/communities/get-left-pane-announcement/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getChapterAnnouncement, { root: true });
                commit(storeMutation.setChapterAnnouncementData, response.data);
                commit(storeMutation.setChapterAnnouncement, response.data.announcement);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const ypoCommonGetters = {
    [storeGetters.chapterChairMessage]: state => state.chairMessage,
    [storeGetters.chapterAnnouncement]: state => state.announcement,
    [storeGetters.eventsList]: state => state.eventsList,
    [storeGetters.membersList]: state => state.membersList,
};

export default {
    namespaced: true,
    state: {
        initialState: ypoCommonState(),
        ...ypoCommonState(),
    },
    mutations: { ...ypoCommonMutations },
    actions: { ...ypoCommonActions },
    getters: { ...ypoCommonGetters },
};
